import { TweenMax, Power3 } from "gsap/TweenMax";
import * as ScrollMagic from 'scrollmagic';
import 'animation.gsap'
import Carousel from '../blocks/carousel';

export default class SlidingImages {

  constructor (slidingSection) {
    this.$slidingSection = $(slidingSection);
    this.$slidingSectionWrapper = $(this.$slidingSection.parent('.container'));
    this.$slidingContainer = $(this.$slidingSection.find('.sliding-images__container'));
    this.$slidingImageWrapper = $(this.$slidingSection.find('.sliding-images__image-wrapper'));
    this.carousel = null;
    this.$images = this.$slidingSection.find('img');
    this.controller = new ScrollMagic.Controller();
    this.tween = null;
    this.scene = null;

    window.addEventListener('resize', () => {
      this.reflow()
    }, true)
    this.reflow()
  }

  mobile_init() {
    this.$slidingContainer.addClass('carousel owl-carousel owl-theme');
    this.$slidingImageWrapper.addClass('carousel__item');
    this.$slidingSectionWrapper.removeClass('container');

    this.carousel = new Carousel(this.$slidingContainer);
  }

  desktop_init() {
    this.$slidingSectionWrapper.addClass('container');

    let slidingTrigger = this.$slidingSection.next('.sliding-images__trigger')[0];
    let scrollAmount = this.$slidingContainer[0].scrollWidth - this.$slidingSection.width();
    let maxHeight = this._getHeight();
    this.$slidingSection.height(maxHeight);
    this.$slidingContainer.css({'position': 'absolute'});
    $(this.$slidingSection)
    .addClass('justify-content-between')
    .removeClass('justify-content-center');

    if(scrollAmount < 210) {
      $(this.$slidingSection)
      .removeClass('justify-content-between')
      .addClass('justify-content-center');
      return;
    }

    this.tween = TweenMax.fromTo(this.$slidingSection[0], 1,
      {
        x: 0,
        rotation: 0.01,
        force3D:true,
        ease: Power3.easeInOut,
      },
      {
        x: -scrollAmount,
        ease: Power3.easeInOut,
        rotation: 0.01,
      });

    this.scene = new ScrollMagic.Scene({
      triggerElement: slidingTrigger,
      duration: this._slideDuration(maxHeight),
      triggerHook: 'onEnter',
      offset: '0',
    })
    .setTween(this.tween)
    .addTo(this.controller);

  }

  mobile_destroy() {
    // destroy owl carousel
    if(this.carousel) {
      this.carousel.destory();
      this.$slidingImageWrapper.removeClass('carousel__item');
    }
  }

  desktop_destroy() {
    if(this.tween == null || this.scene == null) {
      return;
    }

    this.scene.destroy();
    this.tween = null;
    this.scene = null;
  }

  reset() {
    this.mobile_destroy();
    this.desktop_destroy();

    this.$slidingSection.height('auto');
    this.$slidingContainer.css({'position': 'static'});
    this.$slidingSection.css({'transform': 'none' })
  }

  reflow() {
    this.reset();
    if( $(window).width() > 868 ) {
      this.desktop_init();
    } else {
      this.mobile_init();
    }
  }

  _getHeight() {
    let heights = this.$images.map(function (){
        return $(this).height();
    }).get();

    return Math.max.apply(null, heights);
  }

  _slideDuration(height) {
    let duration = 100 - (height / $(window).height()) * 100;
    return duration+'%';
  }

}



// WEBPACK FOOTER //
// ./scripts/blocks/sliding-images.js